<template>
  <div class="patentA contentBack">
  
    <div class="contentBack5">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>商标管理</el-breadcrumb-item>
        <el-breadcrumb-item class="breadSelected">商标分析 </el-breadcrumb-item>
      </el-breadcrumb>
         <div id="pdfDom">
      <!-- 1.筛选 -->
      <div class="analy">
        <!-- 选择地区 -->
        <div class="analySelect">
          <i
            class="el-icon-map-location"
            style="font-size: 17px; color: #000"
          ></i>
          <el-select v-model="region" @change="changeRegion">
            <el-option value="全部区域">全部区域</el-option>
            <el-option
              v-for="item in optionsRegion"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <!-- 选择时间 -->
        <div class="timeblock">
          <i class="iconfont">&#xe6c2;</i>
          <el-cascader
            v-model="timevalue"
            :options="optionsTime"
            @change="handleTimeChange"
          >
          </el-cascader>
        </div>
        <!-- 下载报告 -->
         <div class="downreport" @click="btnClick">
         <i class="iconfont">&#xe6d0;</i> 下载报告
        </div>
      </div>
      <!-- 筛选结束 -->
       
      <!-- 2.统计 -->
      <div class="stats">
       <div class="trademark-one">
         <div class="trademark-img"><i class="iconfont">&#xe6c3;</i></div>
         <div class="trademark-text">
            <div class="trandemark-num">
              <div class="trandemark-tit">
                商标申请量</div>
                 <span>{{dataSummary.tmApNum}}</span> <span class="trandemark-num1">件</span></div>
         </div>
       </div>
              <div class="trademark-one">
         <div class="trademark-img"><i class="iconfont">&#xe6bf;</i></div>
         <div class="trademark-text">
            <div class="trandemark-num">
              <div class="trandemark-tit">
                商标注册量</div>
                 <span>{{ dataSummary.tmRegNum }}</span> <span class="trandemark-num1">件</span></div>
         </div>
       </div>
        <div class="trademark-one">
         <div class="trademark-img"><i class="iconfont">&#xe6c3;</i></div>
         <div class="trademark-text">
            <div class="trandemark-num">
              <div class="trandemark-tit">
                商标有效注册量</div>
                 <span>{{ dataSummary.tmValidRegNum }}</span> <span class="trandemark-num1">件</span></div>
         </div>
       </div>
               <div class="trademark-one">
         <div class="trademark-img"><i class="iconfont">&#xe6c3;</i></div>
         <div class="trademark-text">
            <div class="trandemark-num">
              <div class="trandemark-tit">
                马德里商标注册量</div>
                 <span>{{ dataSummary.madridRegNum }}</span> <span class="trandemark-num1">件</span></div>
         </div>
       </div>
                      <div class="trademark-one">
         <div class="trademark-img"><i class="iconfont">&#xe6bf;</i></div>
         <div class="trademark-text">
            <div class="trandemark-num">
              <div class="trandemark-tit">
                万人有效商标持有量 </div>
                 <span>{{ dataSummary.avgValidNum }}</span> <span class="trandemark-num1">件</span></div>
         </div>
       </div>
                             <div class="trademark-one">
         <div class="trademark-img"><i class="iconfont">&#xe6be;</i></div>
         <div class="trademark-text">
            <div class="trandemark-num">
              <div class="trandemark-tit">
                商标核准转让量 </div>
                 <span>{{ dataSummary.tmTrfNum }}</span> <span class="trandemark-num1">件</span></div>
         </div>
       </div>
                                    <div class="trademark-one">
         <div class="trademark-img"><i class="iconfont">&#xe6c4;</i></div>
         <div class="trademark-text">
            <div class="trandemark-num">
              <div class="trandemark-tit">
                商标许可备案量 </div>
                 <span>{{ dataSummary.tmLicNum }}</span> <span class="trandemark-num1">件</span></div>
         </div>
       </div>
      <div class="trademark-one">
         <div class="trademark-img"><i class="iconfont">&#xe6b7;</i></div>
         <div class="trademark-text">
            <div class="trandemark-num">
              <div class="trandemark-tit">
                商标质押登记量 </div>
                 <span>{{ dataSummary.tmPldNum }}</span> <span class="trandemark-num1">件</span></div>
         </div>
       </div>
      </div>
      
      <!-- 统计结束 -->
        
      <div
        style="height: 11px; width: 100%; background: #f2f2f2; margin-top: 20px"
      ></div>
      <!-- 3.国内商标分析 -->
      <div>
        <div class="analyTitle">
             <div class="inside">
            <div class="inside-title"><div></div>国内商标分析</div>
          </div>
        </div>
        <!-- <div style="margin-top: 22px; margin-bottom: 22px"> -->
          <!-- 3-1.国内商标趋势 -->
          <div id="gntmtrend" class="zl2">
            <div class="checkEchart">
              <div
                @click="switchEchart(1)"
                :class="{ checked: echartsType1 == 1 }"
              >
                <i class="iconfont">&#xe6df;</i>
                <p>柱状图</p>
              </div>
              <div
                @click="switchEchart(2)"
                :class="{ checked: echartsType1 == 2 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
            <p class="biaoTitle">国内商标趋势</p>
            <div v-show="havedata1">
              <!-- 柱状图 -->
              <div
                v-show="echartsType1 == 1"
                class="echartsBox1 domesticsbtrend"
              ></div>
              <!-- 数据视图 -->
              <div v-show="echartsType1 == 2">
                <el-table
                  :data="tmTrendMap"
                  border
                  stripe
                  style="width: 90%; margin: 4% auto 0"
                >
                  <el-table-column :resizable="false" prop="name" label="时间" width="180">
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="申请量" width="180">
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num2" label="注册量">
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div v-show="!havedata1" class="blankimg">
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
          </div>
          <!-- 3-2.国际分类Top10 -->
          <div id="gjtype10"  class="zl2">
            <div class="checkEchart">
              <div
                @click="switchEchart(3)"
                :class="{ checked: echartsType2 == 3 }"
              >
                <i class="iconfont">&#xe6de;</i>
                <p>条形图</p>
              </div>
              <div
                @click="switchEchart(4)"
                :class="{ checked: echartsType2 == 4 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
            <p class="biaoTitle">国际分类Top10</p>
            <div class="sqSwitch">
              <button @click="applybtn(1)" :class="{ numbtn: numType1 == 1 }">
                申请量
              </button>
              <button @click="agreebtn(2)" :class="{ numbtn: numType1 == 2 }">
                注册量
              </button>
            </div>
            <!-- 条形图 -->
            <div
              v-show="echartsType2 == 3 && numType1 == 1 && havedata2"
              class="echartsBox1 intertype101"
            ></div>
            <div
              v-show="echartsType2 == 3 && numType1 == 1 && !havedata2"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div
              v-show="echartsType2 == 3 && numType1 == 2 && havedata3"
              class="echartsBox1 intertype102"
            ></div>
            <div
              v-show="echartsType2 == 3 && numType1 == 2 && !havedata3"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <!-- 数据视图 -->
            <div v-show="echartsType2 == 4 && numType1 == 1 && havedata2">
              <el-table
                :data="icTop10Map"
                border
                stripe
                style="width: 90%; margin: 4% auto 0"
              >
                <el-table-column :resizable="false" type="index" label="排序" width="60">
                </el-table-column>
                <el-table-column :resizable="false" prop="IC" label="国际分类"> </el-table-column>
                <el-table-column :resizable="false" prop="num" label="申请量"> </el-table-column>
              </el-table>
            </div>
            <div
              v-show="echartsType2 == 4 && numType1 == 1 && !havedata2"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div v-show="echartsType2 == 4 && numType1 == 2 && havedata3">
              <el-table
                :data="icRegTop10Map"
                border
                stripe
                style="width: 90%; margin: 4% auto 0"
              >
                <el-table-column :resizable="false" type="index" label="排序" width="60">
                </el-table-column>
                <el-table-column :resizable="false" prop="IC" label="国际分类"> </el-table-column>
                <el-table-column :resizable="false" prop="num" label="注册量"> </el-table-column>
              </el-table>
            </div>
            <div
              v-show="echartsType2 == 4 && numType1 == 2 && !havedata3"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
          </div>
        <!-- </div> -->
        <!-- 3-3.申请人构成及趋势 -->
        <div id="applyertrend" class="zl2">
          <div class="checkEchart">
            <div
              @click="switchEchart(5)"
              :class="{ checked: echartsType3 == 5 }"
            >
              <i class="iconfont">&#xe6e0;</i>
              <p>面积图</p>
            </div>
            <div
              @click="switchEchart(6)"
              :class="{ checked: echartsType3 == 6 }"
            >
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
          </div>
          <p class="biaoTitle2">申请人构成及趋势</p>
          <div class="sqSwitch">
            <button @click="applybtn(3)" :class="{ numbtn: numType2 == 3 }">
              申请量
            </button>
            <button @click="agreebtn(4)" :class="{ numbtn: numType2 == 4 }">
              注册量
            </button>
          </div>
          <!--面积图  -->
          <div
            v-show="echartsType3 == 5 && numType2 == 3 && havedata4"
            class="echartsBox1 applyMakeup1sb"
          ></div>
          <div
            v-show="echartsType3 == 5 && numType2 == 3 && !havedata4"
            class="blankimg"
          >
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div>
          <div
            v-show="echartsType3 == 5 && numType2 == 4 && havedata5"
            class="echartsBox1 applyMakeup2sb"
          ></div>
          <div
            v-show="echartsType3 == 5 && numType2 == 4 && !havedata5"
            class="blankimg"
          >
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div>
          <!-- 数据视图 -->
          <div v-show="echartsType3 == 6 && numType2 == 3 && havedata4">
            <table class="myTable">
              <tr>
                <th>申请人类型</th>
                <th v-for="(item, index) of timeRange" :key="index">
                  {{ item }}
                </th>
              </tr>
              <tr>
                <td>工矿企业</td>
                <td
                  v-for="(gk, gkindex) of this.$store.state.gkcompanysb"
                  :key="gkindex"
                >
                  {{ gk }}
                </td>
              </tr>
              <tr>
                <td>科研院所</td>
                <td
                  v-for="(ky, kyindex) of this.$store.state.sciencedwsb"
                  :key="kyindex"
                >
                  {{ ky }}
                </td>
              </tr>
              <tr>
                <td>大专院校</td>
                <td
                  v-for="(dz, dzindex) of this.$store.state.dzschoolsb"
                  :key="dzindex"
                >
                  {{ dz }}
                </td>
              </tr>
              <tr>
                <td>机关团体</td>
                <td
                  v-for="(jg, jgindex) of this.$store.state.jggroupsb"
                  :key="jgindex"
                >
                  {{ jg }}
                </td>
              </tr>
              <tr>
                <td>个人</td>
                <td
                  v-for="(man, manindex) of this.$store.state.singlesb"
                  :key="manindex"
                >
                  {{ man }}
                </td>
              </tr>
            </table>
          </div>
          <div
            v-show="echartsType3 == 6 && numType2 == 3 && !havedata4"
            class="blankimg"
          >
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div>
          <div v-show="echartsType3 == 6 && numType2 == 4 && havedata5">
            <table class="myTable">
              <tr>
                <th>申请人类型</th>
                <th v-for="(item, index) of timeRange" :key="index">
                  {{ item }}
                </th>
              </tr>
              <tr>
                <td>工矿企业</td>
                <td
                  v-for="(gk, gkindex) of this.$store.state.gkcompanyAuthsb"
                  :key="gkindex"
                >
                  {{ gk }}
                </td>
              </tr>
              <tr>
                <td>科研院所</td>
                <td
                  v-for="(ky, kyindex) of this.$store.state.sciencedwAuthsb"
                  :key="kyindex"
                >
                  {{ ky }}
                </td>
              </tr>
              <tr>
                <td>大专院校</td>
                <td
                  v-for="(dz, dzindex) of this.$store.state.dzschoolAuthsb"
                  :key="dzindex"
                >
                  {{ dz }}
                </td>
              </tr>
              <tr>
                <td>机关团体</td>
                <td
                  v-for="(jg, jgindex) of this.$store.state.jggroupAuthsb"
                  :key="jgindex"
                >
                  {{ jg }}
                </td>
              </tr>
              <tr>
                <td>个人</td>
                <td
                  v-for="(man, manindex) of this.$store.state.singleAuthsb"
                  :key="manindex"
                >
                  {{ man }}
                </td>
              </tr>
            </table>
          </div>
          <div
            v-show="echartsType3 == 6 && numType2 == 4 && !havedata5"
            class="blankimg"
          >
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div>
        </div>
        <!-- 3-4.国内商标分析榜单 -->
        <div id="gntmtop" class="zl2">
          <div class="checkEchart">
            <div
              @click="switchEchart(7)"
              :class="{ checked: echartsType4 == 7 }"
            >
              <i class="iconfont">&#xe6de;</i>
              <p>条形图</p>
            </div>
            <div
              @click="switchEchart(8)"
              :class="{ checked: echartsType4 == 8 }"
            >
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
          </div>
          <p class="biaoTitle2">国内商标分析榜单</p>
          <div class="sqSwitch">
            <button @click="applybtn(5)" :class="{ numbtn: numType3 == 5 }">
              申请量
            </button>
            <button @click="agreebtn(6)" :class="{ numbtn: numType3 == 6 }">
              注册量
            </button>
            <button @click="yxfmbtn(7)" :class="{ numbtn: numType3 == 7 }">
              有效注册量
            </button>
          </div>
          <!-- 条形图 -->
          <div
            v-show="echartsType4 == 7 && numType3 == 5 && havedata6"
            class="echartsBox1 domesticsbtop1"
          ></div>
          <div
            v-show="echartsType4 == 7 && numType3 == 5 && !havedata6"
            class="blankimg"
          >
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div>
          <div
            v-show="echartsType4 == 7 && numType3 == 6 && havedata7"
            class="echartsBox1 domesticsbtop2"
          ></div>
          <div
            v-show="echartsType4 == 7 && numType3 == 6 && !havedata7"
            class="blankimg"
          >
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div>
          <div
            v-show="echartsType4 == 7 && numType3 == 7 && havedata8"
            class="echartsBox1 domesticsbtop3"
          ></div>
          <div
            v-show="echartsType4 == 7 && numType3 == 7 && !havedata8"
            class="blankimg"
          >
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div>
          <!-- 数据视图 -->
          <div v-show="echartsType4 == 8 && numType3 == 5 && havedata6">
            <div class="titleBox">
              <el-button
                @click="seeMore50(101)"
                :disabled="topApp10Map.length === topApp50Map.length"
                >更多</el-button
              >
            </div>
            <el-table :data="topApp10Map" border stripe class="el-tableclass">
              <el-table-column :resizable="false" type="index" label="排序" width="60">
              </el-table-column>
              <el-table-column :resizable="false" prop="name" label="企业名称"> </el-table-column>
              <el-table-column :resizable="false" prop="num" label=" 申请量"> </el-table-column>
            </el-table>
          </div>
          <div
            v-show="echartsType4 == 8 && numType3 == 5 && !havedata6"
            class="blankimg"
          >
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div>
          <div v-show="echartsType4 == 8 && numType3 == 6 && havedata7">
            <div class="titleBox">
              <el-button
                @click="seeMore50(102)"
                :disabled="topReg10Map.length === topReg50Map.length"
                >更多</el-button
              >
            </div>
            <el-table :data="topReg10Map" border stripe class="el-tableclass">
              <el-table-column :resizable="false" type="index" label="排序" width="60">
              </el-table-column>
              <el-table-column :resizable="false" prop="name" label="企业名称"> </el-table-column>
              <el-table-column :resizable="false" prop="num" label="注册量"> </el-table-column>
            </el-table>
          </div>
          <div
            v-show="echartsType4 == 8 && numType3 == 6 && !havedata7"
            class="blankimg"
          >
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div>
          <div v-show="echartsType4 == 8 && numType3 == 7 && havedata8">
            <div class="titleBox">
              <el-button
                @click="seeMore50(103)"
                :disabled="topValid10Map.length === topValid50Map.length"
                >更多</el-button
              >
            </div>
            <el-table :data="topValid10Map" border stripe class="el-tableclass">
              <el-table-column :resizable="false" type="index" label="排序" width="60">
              </el-table-column>
              <el-table-column :resizable="false" prop="name" label="企业名称"> </el-table-column>
              <el-table-column :resizable="false" prop="num" label="有效注册量"> </el-table-column>
            </el-table>
          </div>
          <div
            v-show="echartsType4 == 8 && numType3 == 7 && !havedata8"
            class="blankimg"
          >
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div>
        </div>
      </div>
      <div
        style="height: 20px; width: 100%; background: #f2f2f2; margin-top: 20px"
      ></div>
      <!-- 4.马德里商标分析 -->
      <div>
        <div class="analyTitle">
                 <div class="inside">
            <div class="inside-title"><div></div>马德里商标分析</div>
          </div></div>
        <!-- 4-1.马德里商标趋势 -->
        <div id="mdltmtrend" class="zl2">
          <div class="checkEchart">
            <div
              @click="switchEchart(9)"
              :class="{ checked: echartsType5 == 9 }"
            >
              <i class="iconfont">&#xe6e0;</i>
              <p>面积图</p>
            </div>
            <div
              @click="switchEchart(10)"
              :class="{ checked: echartsType5 == 10 }"
            >
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
          </div>
          <p class="biaoTitle2">马德里商标趋势</p>
          <div v-show="havedata9">
            <!-- 面积图 -->
            <div v-show="echartsType5 == 9" class="echartsBox1 mdl1sb"></div>
            <!-- 数据视图 -->
            <div v-show="echartsType5 == 10">
              <el-table
                :data="madridTrend"
                border
                stripe
                style="width: 90%; margin: 4% auto 0"
              >
                <el-table-column :resizable="false" prop="name" label="时间"> </el-table-column>
                <el-table-column :resizable="false" prop="num" label="公开量"> </el-table-column>
              </el-table>
            </div>
          </div>
          <div v-show="!havedata9" class="blankimg">
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div>
        </div>
        <!-- 4-2.马德里延伸国家TOP20 -->
        <div id="mdltop20" class="zl2">
          <div class="checkEchart">
            <div
              @click="switchEchart(11)"
              :class="{ checked: echartsType6 == 11 }"
            >
              <i class="iconfont">&#xe6df;</i>
              <p>柱状图</p>
            </div>
            <div
              @click="switchEchart(12)"
              :class="{ checked: echartsType6 == 12 }"
            >
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
          </div>
          <p class="biaoTitle2">马德里延伸国家TOP20</p>
          <div v-show="havedata10">
            <!-- 柱状图 -->
            <div v-show="echartsType6 == 11" class="echartsBox1 mdl2sb"></div>
            <!-- 数据视图 -->
            <div v-show="echartsType6 == 12">
              <div style="display: flex; margin: 4% auto 0; width: 70%">
                <el-table :data="madridExtendTop201" border stripe>
                  <el-table-column :resizable="false"
                    type="index"
                    label="排序"
                    width="60"
                  ></el-table-column>
                  <el-table-column :resizable="false" prop="name" label="马德里延伸国家">
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="马德里注册量">
                  </el-table-column>
                </el-table>
                <el-table :data="madridExtendTop202" border stripe>
                  <el-table-column :resizable="false" type="index" label="排序" width="60">
                    <template slot-scope="scope">
                      <span>{{ scope.$index + 11 }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column :resizable="false" prop="name" label="马德里延伸国家">
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="马德里注册量">
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <div v-show="!havedata10" class="blankimg">
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div>
        </div>
        <!-- 4-3.马德里注册量榜单 -->
        <div id="mdlreg" class="zl2" style="margin-bottom: 30px">
          <div class="checkEchart">
            <div
              @click="switchEchart(13)"
              :class="{ checked: echartsType7 == 13 }"
            >
              <i class="iconfont">&#xe6de;</i>
              <p>条形图</p>
            </div>
            <div
              @click="switchEchart(14)"
              :class="{ checked: echartsType7 == 14 }"
            >
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
          </div>
          <p class="biaoTitle2">马德里注册量榜单</p>
          <div v-show="havedata11">
            <!-- 条形图 -->
            <div v-show="echartsType7 == 13" class="echartsBox1 mdl3sb"></div>
            <!-- 数据视图 -->
            <div v-show="echartsType7 == 14">
              <div class="titleBox">
                <el-button
                  @click="seeMore50(112)"
                  :disabled="madridTop10.length === madridTop50.length"
                  >更多</el-button
                >
              </div>
              <el-table
                :data="madridTop10"
                border
                stripe
                style="width: 90%; margin: 0 auto"
              >
                <el-table-column :resizable="false"
                  type="index"
                  label="排序"
                  width="60"
                ></el-table-column>
                <el-table-column :resizable="false" prop="name" label="企业名称">
                </el-table-column>
                <el-table-column :resizable="false" prop="num" label="马德里注册量">
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div v-show="!havedata11" class="blankimg">
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div>
        </div>
      </div>
      <div style="height: 20px; width: 100%; background: #f2f2f2"></div>
      <!--5.商标状态分析  -->
      <div>
        <div class="analyTitle">
                   <div class="inside">
            <div class="inside-title"><div></div>商标状态分析</div>
          </div></div>
        <div id="sbstatusfx" class="zl2" style="margin-bottom: 20px">
          <div class="checkEchart">
            <div
              @click="switchEchart(15)"
              :class="{ checked: echartsType8 == 15 }"
            >
               <i class="iconfont">&#xe6e0;</i>
              <p>饼状图</p>
            </div>
            <div
              @click="switchEchart(16)"
              :class="{ checked: echartsType8 == 16 }"
            >
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
          </div>
          <p class="biaoTitle2">商标状态分析</p>
          <div v-show="havedata12">
            <!--饼状图  -->
            <div v-show="echartsType8 == 15" class="echartsBox1 statusSB"></div>
            <!--数据视图  -->
            <div v-show="echartsType8 == 16">
              <el-table
                :data="lawMap"
                border
                stripe
                style="width: 90%; margin: 4% auto 0"
              >
                <el-table-column :resizable="false" prop="ls" label="法律状态"> </el-table-column>
                <el-table-column :resizable="false" prop="num" label="商标量"> </el-table-column>
              </el-table>
            </div>
          </div>
          <div v-show="!havedata12" class="blankimg">
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div>
        </div>
      </div>
      <div style="height: 20px; width: 100%; background: #f2f2f2"></div>
      <!--6.区域商标比较  -->
      <div>
        <div class="analyTitle">
                   <div class="inside">
            <div class="inside-title"><div></div>区域商标比较</div>
          </div></div> 
        <div id="regiontm" class="zl2" style="margin-bottom: 20px">
          <div class="checkEchart">
            <div
              @click="switchEchart(17)"
              :class="{ checked: echartsType9 == 17 }"
            >
              <i class="iconfont">&#xe6df;</i>
              <p>柱状图</p>
            </div>
            <div
              @click="switchEchart(18)"
              :class="{ checked: echartsType9 == 18 }"
            >
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
          </div>
          <p class="biaoTitle2">区域商标比较</p>
          <div class="sqSwitch">
            <button @click="applybtn(8)" :class="{ numbtn: numType4 == 8 }">
              申请量
            </button>
            <button @click="agreebtn(9)" :class="{ numbtn: numType4 == 9 }">
              注册量
            </button>
            <button @click="yxfmbtn(10)" :class="{ numbtn: numType4 == 10 }">
              马德里注册
            </button>
          </div>
          <!--柱状图  -->
          <div
            v-show="echartsType9 == 17 && numType4 == 8 && havedata13"
            class="echartsBox1 regionsbDCompare1"
          ></div>
          <div
            v-show="echartsType9 == 17 && numType4 == 8 && !havedata13"
            class="blankimg"
          >
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div>
          <div
            v-show="echartsType9 == 17 && numType4 == 9 && havedata14"
            class="echartsBox1 regionsbDCompare2"
          ></div>
          <div
            v-show="echartsType9 == 17 && numType4 == 9 && !havedata14"
            class="blankimg"
          >
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div>
          <div
            v-show="echartsType9 == 17 && numType4 == 10 && havedata15"
            class="echartsBox1 regionsbDCompare3"
          ></div>
          <div
            v-show="echartsType9 == 17 && numType4 == 10 && !havedata15"
            class="blankimg"
          >
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div>
          <!--数据视图  -->
          <div v-show="echartsType9 == 18 && numType4 == 8 && havedata13">
            <el-table
              :data="areaTmCompMap"
              border
              stripe
              style="width: 90%; margin: 4% auto 0"
            >
              <el-table-column :resizable="false" prop="name" label="区域"> </el-table-column>
              <el-table-column :resizable="false" prop="num" label="申请量"> </el-table-column>
            </el-table>
          </div>
          <div
            v-show="echartsType9 == 18 && numType4 == 8 && !havedata13"
            class="blankimg"
          >
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div>
          <div v-show="echartsType9 == 18 && numType4 == 9 && havedata14">
            <el-table
              :data="areaRegTmCompMap"
              border
              stripe
              style="width: 90%; margin: 4% auto 0"
            >
              <el-table-column :resizable="false" prop="name" label="区域"> </el-table-column>
              <el-table-column :resizable="false" prop="num" label="注册量"> </el-table-column>
            </el-table>
          </div>
          <div
            v-show="echartsType9 == 18 && numType4 == 9 && !havedata14"
            class="blankimg"
          >
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div>
          <div v-show="echartsType9 == 18 && numType4 == 10 && havedata15">
            <el-table
              :data="areaMadridTmCompMap"
              border
              stripe
              style="width: 90%; margin: 4% auto 0"
            >
              <el-table-column :resizable="false" prop="name" label="区域"> </el-table-column>
              <el-table-column :resizable="false" prop="num" label="马德里注册量">
              </el-table-column>
            </el-table>
          </div>
          <div
            v-show="echartsType9 == 18 && numType4 == 10 && !havedata15"
            class="blankimg"
          >
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div>
            <div class="other-tips">
                  注：“其他”表示暂时无法识别商标/专利所属区
                </div>
        </div>
      </div>
      <div style="height: 20px; width: 100%; background: #f2f2f2"></div>
      <!-- 7. 商标运营分析-->
      <div>
         <div class="analyTitle">
                   <div class="inside">
            <div class="inside-title"><div></div>商标运营分析</div>
          </div></div> 
        <!-- <div class="zl2" style="margin-top: 22px; margin-bottom: 22px"> -->
          <!-- 7-1.商标转让趋势 -->
          <div id="sbturn1" class="zl2" style="margin-bottom: 20px">
            <div class="checkEchart">
              <div
                @click="switchEchart(19)"
                :class="{ checked: echartsType10 == 19 }"
              >
                <i class="iconfont">&#xe6e0; </i>
                <p>面积图</p>
              </div>
              <div
                @click="switchEchart(20)"
                :class="{ checked: echartsType10 == 20 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
            <p class="biaoTitle">商标转让趋势</p>
            <div v-show="havedata16">
              <!-- 面积图 -->
              <div
                v-show="echartsType10 == 19"
                class="echartsBox1 sbmani1SB"
              ></div>
              <!-- 数据视图 -->
              <div v-show="echartsType10 == 20">
                <el-table
                  :data="tmTransferMap"
                  border
                  stripe
                  style="width: 90%; margin: 4% auto 0"
                >
                  <el-table-column :resizable="false" prop="name" label="时间"> </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="转让量"> </el-table-column>
                </el-table>
              </div>
            </div>
            <div v-show="!havedata16" class="blankimg">
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
          </div>
          <!-- 7-2.商标转让类别Top10 -->
          <div id="sbturn2" class="zl2" style="margin-bottom: 20px">
            <div class="checkEchart">
              <div
                @click="switchEchart(21)"
                :class="{ checked: echartsType11 == 21 }"
              >
                <i class="iconfont">&#xe6de;</i>
                <p>条形图</p>
              </div>
              <div
                @click="switchEchart(22)"
                :class="{ checked: echartsType11 == 22 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
            <p class="biaoTitle">商标转让类别Top10</p>
            <div v-show="havedata17">
              <!-- 条形图 -->
              <div
                v-show="echartsType11 == 21"
                class="echartsBox1 sbmani2SB"
              ></div>
              <!-- 数据视图 -->
              <div v-show="echartsType11 == 22">
                <el-table
                  :data="tmIcTrfTop"
                  border
                  stripe
                  style="width: 90%; margin: 4% auto 0"
                >
                  <el-table-column :resizable="false" type="index" label="排序" width="60">
                  </el-table-column>
                  <el-table-column :resizable="false" prop="name" label="国际分类">
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="转让量"> </el-table-column>
                </el-table>
              </div>
            </div>
            <div v-show="!havedata17" class="blankimg">
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
          </div>
        <!-- </div> -->
        <!-- <div class="zl2" style="margin-top: 22px; margin-bottom: 22px"> -->
          <!-- 7-3.商标许可趋势 -->
          <div id="sbagree1" class="zl2" style="margin-top: 22px; margin-bottom: 22px">
            <div class="checkEchart">
              <div
                @click="switchEchart(23)"
                :class="{ checked: echartsType12 == 23 }"
              >
                <i class="iconfont">&#xe6e0;</i>
                <p>面积图</p>
              </div>
              <div
                @click="switchEchart(24)"
                :class="{ checked: echartsType12 == 24 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
            <p class="biaoTitle">商标许可趋势</p>
            <div v-show="havedata18">
              <!-- 面积图 -->
              <div
                v-show="echartsType12 == 23"
                class="echartsBox1 sbmani3SB"
              ></div>
              <!-- 数据视图 -->
              <div v-show="echartsType12 == 24">
                <el-table
                  :data="tmLicenseMap"
                  border
                  stripe
                  style="width: 90%; margin: 4% auto 0"
                >
                  <el-table-column :resizable="false" prop="name" label="时间"> </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="许可量"> </el-table-column>
                </el-table>
              </div>
            </div>
            <div v-show="!havedata18" class="blankimg">
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
          </div>
          <!-- 7-4.商标许可类别Top10 -->
          <div id="sbagree2" class="zl2" style="margin-top: 22px; margin-bottom: 22px">
            <div class="checkEchart">
              <div
                @click="switchEchart(25)"
                :class="{ checked: echartsType13 == 25 }"
              >
                <i class="iconfont">&#xe6de;</i>
                <p>条形图</p>
              </div>
              <div
                @click="switchEchart(26)"
                :class="{ checked: echartsType13 == 26 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
            <p class="biaoTitle">商标许可类别Top10</p>
            <div v-show="havedata19">
              <!-- 条形图 -->
              <div
                v-show="echartsType13 == 25"
                class="echartsBox1 sbmani4SB"
              ></div>
              <!-- 数据视图 -->
              <div v-show="echartsType13 == 26">
                <el-table
                  :data="tmIcLicTop"
                  border
                  stripe
                  style="width: 90%; margin: 4% auto 0"
                >
                  <el-table-column :resizable="false" type="index" label="排序" width="60">
                  </el-table-column>
                  <el-table-column :resizable="false" prop="name" label="国际分类">
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="许可量"> </el-table-column>
                </el-table>
              </div>
            </div>
            <div v-show="!havedata19" class="blankimg">
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
          </div>
        <!-- </div> -->
        <!-- <div class="zl2" style="margin-top: 22px; margin-bottom: 22px"> -->
          <!-- 7-5.商标质押趋势 -->
          <div id="sbzy1" class="zl2" style="margin-top: 22px; margin-bottom: 22px">
            <div class="checkEchart">
              <div
                @click="switchEchart(27)"
                :class="{ checked: echartsType14 == 27 }"
              >
                <i class="iconfont">&#xe6e0;</i>
                <p>面积图</p>
              </div>
              <div
                @click="switchEchart(28)"
                :class="{ checked: echartsType14 == 28 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
            <p class="biaoTitle">商标质押趋势</p>
            <div v-show="havedata20">
              <!-- 面积图 -->
              <div
                v-show="echartsType14 == 27"
                class="echartsBox1 sbmani5SB"
              ></div>
              <!-- 数据视图 -->
              <div v-show="echartsType14 == 28">
                <el-table
                  :data="tmPledgeMap"
                  border
                  stripe
                  style="width: 90%; margin: 4% auto 0"
                >
                  <el-table-column :resizable="false" prop="name" label="时间"> </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="质押量"> </el-table-column>
                </el-table>
              </div>
            </div>
            <div v-show="!havedata20" class="blankimg">
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
          </div>
          <!-- 7-6.商标质押类别Top10 -->
          <div id="sbzy2" class="zl2" style="margin-top: 22px; margin-bottom: 22px">
            <div class="checkEchart">
              <div
                @click="switchEchart(29)"
                :class="{ checked: echartsType15 == 29 }"
              >
                <i class="iconfont">&#xe6de;</i>
                <p>条形图</p>
              </div>
              <div
                @click="switchEchart(30)"
                :class="{ checked: echartsType15 == 30 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
            <p class="biaoTitle">商标质押类别Top10</p>
            <div v-show="havedata21">
              <!-- 条形图 -->
              <div
                v-show="echartsType15 == 29"
                class="echartsBox1 sbmani6SB"
              ></div>
              <!-- 数据视图 -->
              <div v-show="echartsType15 == 30">
                <el-table
                  :data="tmIcPldTop"
                  border
                  stripe
                  style="width: 90%; margin: 4% auto 0"
                >
                  <el-table-column :resizable="false" type="index" label="排序" width="60">
                  </el-table-column>
                  <el-table-column :resizable="false" prop="name" label="国际分类">
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="质押量"> </el-table-column>
                </el-table>
              </div>
            </div>
            <div v-show="!havedata21" class="blankimg">
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
          </div>
        <!-- </div> -->
        <!-- 7-7. 商标运营分析榜单-->
        <div id="sbmanitop" class="zl2">
          <div class="checkEchart">
            <div
              @click="switchEchart(31)"
              :class="{ checked: echartsType16 == 31 }"
            >
              <i class="iconfont">&#xe6de;</i>
              <p>条形图</p>
            </div>
            <div
              @click="switchEchart(32)"
              :class="{ checked: echartsType16 == 32 }"
            >
              <i class="iconfont">&#xe6af;</i>
              <p>数据视图</p>
            </div>
          </div>
          <p class="biaoTitle2">商标运营分析榜单</p>
          <div class="sqSwitch">
            <button @click="applybtn(13)" :class="{ numbtn: numType6 == 13 }">
              商标转让量
            </button>
            <button @click="agreebtn(14)" :class="{ numbtn: numType6 == 14 }">
              商标许可量
            </button>
            <button @click="yxfmbtn(15)" :class="{ numbtn: numType6 == 15 }">
              商标质押量
            </button>
          </div>
          <!-- 条形图 -->
          <div
            v-show="echartsType16 == 31 && numType6 == 13 && havedata22"
            class="echartsBox1 sbmani7SB"
          ></div>
          <div
            v-show="echartsType16 == 31 && numType6 == 13 && !havedata22"
            class="blankimg"
          >
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div>
          <div
            v-show="echartsType16 == 31 && numType6 == 14 && havedata23"
            class="echartsBox1 sbmani7xkSB"
          ></div>
          <div
            v-show="echartsType16 == 31 && numType6 == 14 && !havedata23"
            class="blankimg"
          >
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div>
          <div
            v-show="echartsType16 == 31 && numType6 == 15 && havedata24"
            class="echartsBox1 sbmani7zySB"
          ></div>
          <div
            v-show="echartsType16 == 31 && numType6 == 15 && !havedata24"
            class="blankimg"
          >
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div>
          <!-- 数据视图 -->
          <div v-show="echartsType16 == 32 && numType6 == 13 && havedata22">
            <div class="titleBox">
              <el-button
                @click="seeMore50(106)"
                :disabled="tmTrfTop10.length === tmTrfTop50.length"
                >更多</el-button
              >
            </div>
            <el-table :data="tmTrfTop10" border stripe class="el-tableclass">
              <el-table-column :resizable="false" type="index" label="排序" width="60">
              </el-table-column>
              <el-table-column :resizable="false" prop="name" label="企业名称"> </el-table-column>
              <el-table-column :resizable="false" prop="num" label="商标转让量"> </el-table-column>
            </el-table>
          </div>
          <div
            v-show="echartsType16 == 32 && numType6 == 13 && !havedata22"
            class="blankimg"
          >
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div>
          <div v-show="echartsType16 == 32 && numType6 == 14 && havedata23">
            <div class="titleBox">
              <el-button
                @click="seeMore50(107)"
                :disabled="tmLicTop10.length === tmLicTop50.length"
                >更多</el-button
              >
            </div>
            <el-table :data="tmLicTop10" border stripe class="el-tableclass">
              <el-table-column :resizable="false" type="index" label="排序" width="60">
              </el-table-column>
              <el-table-column :resizable="false" prop="name" label="企业名称"> </el-table-column>
              <el-table-column :resizable="false" prop="num" label="商标许可量"> </el-table-column>
            </el-table>
          </div>
          <div
            v-show="echartsType16 == 32 && numType6 == 14 && !havedata23"
            class="blankimg"
          >
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div>
          <div v-show="echartsType16 == 32 && numType6 == 15 && havedata24">
            <div class="titleBox">
              <el-button
                @click="seeMore50(108)"
                :disabled="tmPldTop10.length === tmPldTop50.length"
                >更多</el-button
              >
            </div>
            <el-table :data="tmPldTop10" border stripe class="el-tableclass">
              <el-table-column :resizable="false" type="index" label="排序" width="60">
              </el-table-column>
              <el-table-column :resizable="false" prop="name" label="企业名称"> </el-table-column>
              <el-table-column :resizable="false" prop="num" label="商标质押量"> </el-table-column>
            </el-table>
          </div>
          <div
            v-show="echartsType16 == 32 && numType6 == 15 && !havedata24"
            class="blankimg"
          >
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div>
        </div>
      </div>
      <div style="height: 20px; width: 100%; background: #f2f2f2"></div>
      <!-- 8.区域服务机构分析 -->
      <div>
          <div class="analyTitle">
                   <div class="inside">
            <div class="inside-title"><div></div>区域服务机构分析</div>
          </div></div> 
        <!-- <div class="zl2" style="margin-top: 22px; margin-bottom: 22px"> -->
          <!-- 8-1.代理机构数量分布 -->
          <div id="sbdlnum" class="zl2 blueborder">
            <div class="checkEchart">
              <div
                @click="switchEchart(33)"
                :class="{ checked: echartsType17 == 33 }"
              >
                <i class="iconfont">&#xe6e0;</i>
                <p>饼状图</p>
              </div>
              <div
                @click="switchEchart(34)"
                :class="{ checked: echartsType17 == 34 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
            <p class="biaoTitle2">代理机构数量分布</p>
            <div v-show="havedata25">
              <!-- 面积图 -->
              <div
                v-show="echartsType17 == 33"
                class="echartsBox1 sbdlnum"
              ></div>
              <!-- 数据视图 -->
              <div v-show="echartsType17 == 34">
                <el-table
                  :data="agentDist"
                  border
                  stripe
                  style="width: 90%; margin: 4% auto 0"
                >
                  <el-table-column :resizable="false" prop="name" label="代理量区间">
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="代理机构数量">
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div v-show="!havedata25" class="blankimg">
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
          </div>
          <!-- 8-2.商标代理量Top10 -->
          <div id="sbdlnumtop" class="zl2 blueborder">
            <div class="checkEchart">
              <div
                @click="switchEchart(35)"
                :class="{ checked: echartsType18 == 35 }"
              >
                <i class="iconfont">&#xe6de;</i>
                <p>条形图</p>
              </div>
              <div
                @click="switchEchart(36)"
                :class="{ checked: echartsType18 == 36 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
            <p class="biaoTitle2">商标代理量Top10</p>
            <div v-show="havedata26">
              <!-- 条形图 -->
              <div
                v-show="echartsType18 == 35"
                class="echartsBox1 sbslnumtop"
              ></div>
              <!-- 数据视图 -->
              <div v-show="echartsType18 == 36">
                <div class="titleBox">
                  <el-button
                    @click="seeMore50(109)"
                    :disabled="agentTmTop10.length === agentTmTop50.length"
                    >更多</el-button
                  >
                </div>
                <el-table
                  :data="agentTmTop10"
                  border
                  stripe
                  style="width: 90%; margin: auto"
                >
                  <el-table-column :resizable="false" type="index" label="排序" width="60">
                  </el-table-column>
                  <el-table-column :resizable="false" prop="AG" label="代理机构">
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="商标代理量">
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div v-show="!havedata26" class="blankimg">
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
          </div>
        <!-- </div> -->
      </div>
      <div style="height: 20px; width: 100%; background: #f2f2f2"></div>
      <!-- 9.区域非正常申请分析 -->
      <div>
         <div class="analyTitle">
                   <div class="inside">
            <div class="inside-title"><div></div>区域非正常申请分析</div>
          </div></div> 
        <!-- <div class="zl2" style="margin-top: 22px; margin-bottom: 22px"> -->
          <!-- 9-1.非正常商标申请人分布 -->
          <div id="notnormalsb" class="zl2 blueborder" style="margin-top: 22px; margin-bottom: 22px" >
            <div class="checkEchart">
              <div
                @click="switchEchart(37)"
                :class="{ checked: echartsType19 == 37 }"
              >
                 <i class="iconfont">&#xe6e0;</i>
                <p>饼状图</p>
              </div>
              <div
                @click="switchEchart(38)"
                :class="{ checked: echartsType19 == 38 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
            <p class="biaoTitle2">非正常商标申请人分布</p>
            <div v-show="havedata27">
              <!-- 面积图 -->
              <div
                v-show="echartsType19 == 37"
                class="echartsBox1 noNormalsb"
              ></div>
              <!-- 数据视图 -->
              <div v-show="echartsType19 == 38">
                <el-table
                  :data="malice"
                  border
                  stripe
                  style="width: 90%; margin: 4% auto 0"
                >
                  <el-table-column :resizable="false" prop="name" label="代理量区间">
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="非正常商标申请人数量">
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div v-show="!havedata27" class="blankimg">
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
          </div>
          <!-- 9-2.非正常申请商标申请量Top10 -->
          <div id="notnormalsbtop" class="zl2 blueborder">
            <div class="checkEchart">
              <div
                @click="switchEchart(39)"
                :class="{ checked: echartsType20 == 39 }"
              >
                <i class="iconfont">&#xe6de;</i>
                <p>条形图</p>
              </div>
              <div
                @click="switchEchart(40)"
                :class="{ checked: echartsType20 == 40 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
            <p class="biaoTitle2">非正常申请商标申请量Top10</p>
            <div v-show="havedata28">
              <!-- 条形图 -->
              <div
                v-show="echartsType20 == 39"
                class="echartsBox1 malicetop"
              ></div>
              <!-- 数据视图 -->
              <div v-show="echartsType20 == 40">
                <div class="titleBox">
                  <el-button
                    @click="seeMore50(110)"
                    :disabled="
                      maliceAppTmTop10.length === maliceAppTmTop50.length
                    "
                    >更多</el-button
                  >
                </div>
                <el-table
                  :data="maliceAppTmTop10"
                  border
                  stripe
                  style="width: 90%; margin: auto"
                >
                  <el-table-column :resizable="false" type="index" label="排序" width="60">
                  </el-table-column>
                  <el-table-column :resizable="false" prop="ap" label="企业名称">
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="商标申请量">
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div v-show="!havedata28" class="blankimg">
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
          </div>
        <!-- </div> -->
      </div>
      <div style="height: 30px; width: 100%; background: #f2f2f2"></div>
    </div>
    </div>
    <!-- ****右边定位box -->
    <div
      class="positionBoxCotrol"
      @click="positionBoxShow"
      :class="{ turnLeft11: ispositionBox }"
    >
      <i
        :class="{ arrowrotate: ispositionBox, norotate: !ispositionBox }"
        class="el-icon-arrow-right"
      ></i>
      <i
        :class="{ arrowrotate: ispositionBox, norotate: !ispositionBox }"
        class="el-icon-arrow-right"
      ></i>
    </div>
    <div
      class="positionBox"
      :class="{ cotrolshow: ispositionBox, cotrolnotshow: !ispositionBox }"
    >
      <div style="position: relative">
        <p>国内商标分析</p>
        <a
          :class="{ visited: avisit == 1 }"
          @click="turnAstyle(1, '#gntmtrend')"
          >国内商标趋势</a
        >
        <a :class="{ visited: avisit == 2 }" @click="turnAstyle(2, '#gjtype10')"
          >国际分类Top10</a
        >
        <a
          :class="{ visited: avisit == 3 }"
          @click="turnAstyle(3, '#applyertrend')"
          >申请人构成及趋势</a
        >
        <a :class="{ visited: avisit == 4 }" @click="turnAstyle(4, '#gntmtop')"
          >国内商标分析榜单</a
        >
        <p>马德里商标分析</p>
        <a
          :class="{ visited: avisit == 5 }"
          @click="turnAstyle(5, '#mdltmtrend')"
          >马德里商标趋势</a
        >
        <a :class="{ visited: avisit == 6 }" @click="turnAstyle(6, '#mdltop20')"
          >马德里延伸国家 Top20</a
        >
        <a :class="{ visited: avisit == 7 }" @click="turnAstyle(7, '#mdlreg')"
          >马德里注册量榜单</a
        >
        <p>
          <a
            :class="{ visited: avisit == 8 }"
            @click="turnAstyle(8, '#sbstatusfx')"
            style="margin-left: 0"
            >商标状态分析</a
          >
        </p>
        <p>
          <a
            :class="{ visited: avisit == 9 }"
            @click="turnAstyle(9, '#regiontm')"
            style="margin-left: 0"
            >区域商标比较</a
          >
        </p>
        <p>商标运营分析</p>
        <a
          :class="{ visited: avisit == 10 }"
          @click="turnAstyle(10, '#sbturn1')"
          >商标核准转让</a
        >
        <a
          :class="{ visited: avisit == 11 }"
          @click="turnAstyle(11, '#sbagree1')"
          >商标许可备案</a
        >
        <a :class="{ visited: avisit == 12 }" @click="turnAstyle(12, '#sbzy1')"
          >商标质押登记</a
        >
        <a
          :class="{ visited: avisit == 13 }"
          @click="turnAstyle(13, '#sbmanitop')"
          >商标运营分析榜单</a
        >
        <p>区域服务机构分析</p>
        <a
          :class="{ visited: avisit == 14 }"
          @click="turnAstyle(14, '#sbdlnum')"
          >代理机构数量分布</a
        >
        <a
          :class="{ visited: avisit == 15 }"
          @click="turnAstyle(15, '#sbdlnumtop')"
          >服务机构分析榜单</a
        >
        <p>区域非正常申请分析</p>
        <a
          :class="{ visited: avisit == 16 }"
          @click="turnAstyle(16, '#notnormalsb')"
          >非正常申请商标申请量分布</a
        >
        <a
          :class="{ visited: avisit == 17 }"
          @click="turnAstyle(17, '#notnormalsbtop')"
          >非正常申请分析榜单</a
        >
      </div>
    </div>
    <!-- ****************** -->
    <!-- *****更多 弹框 -->
    <div v-if="seeMore" class="popBoxMask"></div>
    <div v-if="seeMore" class="popBox">
      <div class="boxHeader">
        {{ label50 }}排名
        <i class="el-icon-close" @click="closeMore"> </i>
      </div>
      <div class="boxContent">
        <div class="titleBox" style="width: 100%; margin-top: 0">
          <span
            style="
              font-size: 18px;
              color: #000;
              text-align: left;
              margin-left: 28px;
              line-height: 50px;
              font-weight: bold;
            "
            >{{ label50 }}Top50</span
          >
          <el-button @click="daochu(label50)">导出Excel</el-button>
        </div>
        <el-table :data="tableData50" border style="width: 100%">
          <el-table-column :resizable="false" type="index" label="序号" width="60">
          </el-table-column>
          <el-table-column :resizable="false" prop="name" label="企业名称"></el-table-column>
          <el-table-column :resizable="false" prop="num" :label="label50"> </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- ************* -->
  </div>
</template>
<script>
import Trademarke from "../assets/js/diagrams/Trademarke";
export default {
  data() {
    return {
      exportPDFtitle:'商标分析报告',
      arrowid: true,
      seeMore: false,
      region: "全部区域",
      timevalue: [],
      timevalueS: "",
      optionsTime: [
        {
          value: "2021",
          label: "2021年",
          children: [
            {
              value: "",
              label: "全部",
            },
            {
              value: "1",
              label: "第一季度",
            },
            {
              value: "2",
              label: "第二季度",
            },
            {
              value: "3",
              label: "第三季度",
            },
            {
              value: "4",
              label: "第四季度",
            },
          ],
        },
        {
          value: "2020",
          label: "2020年",
          children: [
            {
              value: "",
              label: "全部",
            },
            {
              value: "1",
              label: "第一季度",
            },
            {
              value: "2",
              label: "第二季度",
            },
            {
              value: "3",
              label: "第三季度",
            },
            {
              value: "4",
              label: "第四季度",
            },
          ],
        },
      ],
      optionsRegion: [],
      ispositionBox: false,
      avisit: 0,
      echartsType1: 1,
      echartsType2: 3,
      echartsType3: 5,
      echartsType4: 7,
      numType1: 1,
      numType2: 3,
      numType3: 5,
      numType4: 8,
      // numType5: 11,
      numType6: 13,
      echartsType5: 9,
      echartsType6: 11,
      echartsType7: 13,
      echartsType8: 15,
      echartsType9: 17,
      echartsType10: 19,
      echartsType11: 21,
      echartsType12: 23,
      echartsType13: 25,
      echartsType14: 27,
      echartsType15: 29,
      echartsType16: 31,
      echartsType17: 33,
      echartsType18: 35,
      echartsType19: 37,
      echartsType20: 39,
      firstscroll1: true,
      firstscroll2: true,
      firstscroll3: true,
      firstscroll4: true,
      firstscroll5: true,
      firstscroll6: true,
      dataSummary: {},
      tmTrendMap: [],
      icTop10Map: [],
      icRegTop10Map: [],
      timeRange: [],
      topApp10Map: [],
      topApp50Map: [],
      topReg10Map: [],
      topReg50Map: [],
      topValid10Map: [],
      topValid50Map: [],
      lawMap: [],
      areaTmCompMap: [],
      areaRegTmCompMap: [],
      areaMadridTmCompMap: [],
      tmTransferMap: [],
      tmPledgeMap: [],
      tmLicenseMap: [],
      tmIcTrfTop: [],
      tmIcPldTop: [],
      tmIcLicTop: [],
      tmLicTop10: [],
      tmLicTop50: [],
      tmPldTop10: [],
      tmPldTop50: [],
      tmTrfTop10: [],
      tmTrfTop50: [],
      agentDist: [],
      agentTmTop10: [],
      agentTmTop50: [],
      malice: [],
      maliceAppTmTop10: [],
      maliceAppTmTop50: [],

      pctTop10Count: [],
      pctTop50Count: [],
      pctTrendCount: [],
      pctIpcTop10: [],
      tableData50: [],
      label50: "",
      madridTrend: [],
      madridExtendTop201: [],
      madridExtendTop202: [],
      madridTop50: [],
      madridTop10: [],
      havedata1: true,
      havedata2: true,
      havedata3: true,
      havedata4: true,
      havedata5: true,
      havedata6: true,
      havedata7: true,
      havedata8: true,
      havedata9: true,
      havedata10: true,
      havedata11: true,
      havedata12: true,
      havedata13: true,
      havedata14: true,
      havedata15: true,
      havedata16: true,
      havedata17: true,
      havedata18: true,
      havedata19: true,
      havedata20: true,
      havedata21: true,
      havedata22: true,
      havedata23: true,
      havedata24: true,
      havedata25: true,
      havedata26: true,
      havedata27: true,
      havedata28: true,
    };
  },
  methods: {
    // 下载报告
      btnClick() {
      this.$nextTick(() => {
        this.getPdf()
      })
    },
    // 商标分析统计
    sbAnalyCount() {
      this.$GET("/trademark/alyCount", {
        cnty: this.region,
        time: this.timevalueS,
        // time:"2018"
      }).then((res) => {
        // console.log(res);
        this.dataSummary = res.data;
      });
    },
    // 关闭更多弹框
    closeMore() {
      this.seeMore = false;
    },
    //   选择地区
    changeRegion(val) {
      //   console.log(val)
      this.region = val;
      this.firstscroll1 = true;
      this.firstscroll2 = true;
      this.firstscroll3 = true;
      this.firstscroll4 = true;
      this.firstscroll5 = true;
      this.firstscroll6 = true;
      this.sbAnalyCount();
      this.domasticsbDatas();
      this.scrollHandle();
    },
    // 选择时间
    handleTimeChange(value) {
      this.timevalueS = value.join("");
      this.firstscroll1 = true;
      this.firstscroll2 = true;
      this.firstscroll3 = true;
      this.firstscroll4 = true;
      this.firstscroll5 = true;
      this.firstscroll6 = true;
      this.sbAnalyCount();
      this.domasticsbDatas();
      //   console.log(this.trendApListzl)
      this.scrollHandle();
    },
    //   控制定位box
    positionBoxShow() {
      this.ispositionBox = this.ispositionBox ? false : true;
      if (this.ispositionBox == false) {
        this.avisit = 0;
      }
    },
    turnAstyle(value, idName) {
      this.avisit = value;
      document.querySelector(idName).scrollIntoView(true);
    },
    // 切换图表图标
    switchEchart(val) {
      switch (val) {
        case 1:
          this.echartsType1 = 1;
          break;
        case 2:
          this.echartsType1 = 2;
          break;
        case 3:
          this.echartsType2 = 3;
          break;
        case 4:
          this.echartsType2 = 4;
          break;
        case 5:
          this.echartsType3 = 5;
          break;
        case 6:
          this.echartsType3 = 6;
          break;
        case 7:
          this.echartsType4 = 7;
          break;
        case 8:
          this.echartsType4 = 8;
          break;
        case 9:
          this.echartsType5 = 9;
          break;
        case 10:
          this.echartsType5 = 10;
          break;
        case 11:
          this.echartsType6 = 11;
          break;
        case 12:
          this.echartsType6 = 12;
          break;
        case 13:
          this.echartsType7 = 13;
          break;
        case 14:
          this.echartsType7 = 14;
          break;
        case 15:
          this.echartsType8 = 15;
          break;
        case 16:
          this.echartsType8 = 16;
          break;
        case 17:
          this.echartsType9 = 17;
          break;
        case 18:
          this.echartsType9 = 18;
          break;
        case 19:
          this.echartsType10 = 19;
          break;
        case 20:
          this.echartsType10 = 20;
          break;
        case 21:
          this.echartsType11 = 21;
          break;
        case 22:
          this.echartsType11 = 22;
          break;
        case 23:
          this.echartsType12 = 23;
          break;
        case 24:
          this.echartsType12 = 24;
          break;
        case 25:
          this.echartsType13 = 25;
          break;
        case 26:
          this.echartsType13 = 26;
          break;
        case 27:
          this.echartsType14 = 27;
          break;
        case 28:
          this.echartsType14 = 28;
          break;
        case 29:
          this.echartsType15 = 29;
          break;
        case 30:
          this.echartsType15 = 30;
          break;
        case 31:
          this.echartsType16 = 31;
          break;
        case 32:
          this.echartsType16 = 32;
          break;
        case 33:
          this.echartsType17 = 33;
          break;
        case 34:
          this.echartsType17 = 34;
          break;
        case 35:
          this.echartsType18 = 35;
          break;
        case 36:
          this.echartsType18 = 36;
          break;
        case 37:
          this.echartsType19 = 37;
          break;
        case 38:
          this.echartsType19 = 38;
          break;
        case 39:
          this.echartsType20 = 39;
          break;
        case 40:
          this.echartsType20 = 40;
          break;
      }
    },
    // 申请量/授权量切换
    applybtn(val) {
      switch (val) {
        case 1:
          this.numType1 = 1;
          break;
        case 3:
          this.numType2 = 3;
          break;
        case 5:
          this.numType3 = 5;
          break;
        case 8:
          this.numType4 = 8;
          break;
        // case 11:
        //   this.numType5 = 11;
        //   break;
        case 13:
          this.numType6 = 13;
          break;
      }
    },
    agreebtn(val) {
      switch (val) {
        case 2:
          this.numType1 = 2;
          break;
        case 4:
          this.numType2 = 4;
          break;
        case 6:
          this.numType3 = 6;
          break;
        case 9:
          this.numType4 = 9;
          break;
        // case 12:
        //   this.numType5 = 12;
        //   break;
        case 14:
          this.numType6 = 14;
          break;
      }
    },
    yxfmbtn(val) {
      switch (val) {
        case 7:
          this.numType3 = 7;
          break;
        case 10:
          this.numType4 = 10;
          break;
        case 15:
          this.numType6 = 15;
          break;
      }
    },
    // 封装转换年季度时间格式的方法
    switchTime(value) {
      var e, y;
      if (value.toString().split("").length == 4) {
        value = value + "年";
      } else if (value.toString().split("").length == 5) {
        e = value.slice(-1);
        // console.log(e)
        if (e == "1") {
          e = "第一季度";
        } else if (e == "2") {
          e = "第二季度";
        } else if (e == "3") {
          e = "第三季度";
        } else if (e == "4") {
          e = "第四季度";
        }
        y = value.slice(0, 4);
        value = y + "年" + e;
      }
      return value;
      //  console.log(value)
    },

    // 获取国内商标分析的方法
    domasticsbDatas() {
      this.$GET("/trademark/domesticTmAly", {
        cnty: this.region,
        time: this.timevalueS,
        // time: "2019",
      }).then((res) => {
        this.$store.commit("getsbdatas", res.data);
        // 国内商标分析
        //1.
        if (res.data.tmTrendMap.length == 0) {
          this.havedata1 = false;
        } else {
          this.havedata1 = true;
          this.tmTrendMap = res.data.tmTrendMap;
          this.tmTrendMap.forEach((ele) => {
            ele.name = this.switchTime(ele.name);
          });
        }

        Trademarke.domesticsbtrend();
        //2.
        if (res.data.icTop10Map.length == 0) {
          this.havedata2 = false;
        } else {
          this.havedata2 = true;
          this.icTop10Map = res.data.icTop10Map;
        }
        if (res.data.icRegTop10Map.length == 0) {
          this.havedata3 = false;
        } else {
          this.havedata3 = true;
          this.icRegTop10Map = res.data.icRegTop10Map;
        }
        Trademarke.intertype101();
        Trademarke.intertype102();
        // 3.
        if (res.data.apTyTrendForm.length == 0) {
          this.havedata4 = false;
        } else {
          this.havedata4 = true;
        }
        if (res.data.apTyAuthTrendForm.length == 0) {
          this.havedata5 = false;
        } else {
          this.havedata5 = true;
        }
        this.timeRange = res.data.time;
        Trademarke.applyMakeup1sb();
        Trademarke.applyMakeup2sb();
      });
    },
    // 获取国内商标分析榜单
    gettopsb() {
      this.$GET("/trademark/domesticTmAlyTop", {
        cnty: this.region,
        time: this.timevalueS,
        // time: "2019",
      }).then((res) => {
        this.$store.commit("getsbTop", res.data);
        if (res.data.topApp10Map.length == 0) {
          this.havedata6 = false;
        } else {
          this.havedata6 = true;
          this.topApp10Map = res.data.topApp10Map;
          this.topApp50Map = res.data.topApp50Map;
        }
        if (res.data.topReg10Map.length == 0) {
          this.havedata7 = false;
        } else {
          this.havedata7 = true;
          this.topReg10Map = res.data.topReg10Map;
          this.topReg50Map = res.data.topReg50Map;
        }
        if (res.data.topValid10Map.length == 0) {
          this.havedata8 = false;
        } else {
          this.havedata8 = true;
          this.topValid10Map = res.data.topValid10Map;
          this.topValid50Map = res.data.topValid50Map;
        }

        Trademarke.domesticsbtop1();
        Trademarke.domesticsbtop2();
        Trademarke.domesticsbtop3();
      });
    },
    // 获取马德里
    getmdlsb() {
      this.$GET("/trademark/tmMadridAly", {
        cnty: this.region,
        time: this.timevalueS,
        // time: "2012",
      }).then((res) => {
        this.$store.commit("mdlsb", res.data);
        // 马德里
        if (res.data.madridTrend.length == 0) {
          this.havedata9 = false;
        } else {
          this.havedata9 = true;
          this.madridTrend = res.data.madridTrend;
          if (this.madridTrend.length > 0) {
            this.madridTrend.forEach((ele) => {
              ele.name = this.switchTime(ele.name);
            });
          }
        }
        if (res.data.madridExtendTop20.length == 0) {
          this.havedata10 = false;
        } else {
          this.havedata10 = true;
          let madridExtendTop20 = res.data.madridExtendTop20;
          this.madridExtendTop201 = madridExtendTop20.slice(0, 10);
          this.madridExtendTop202 = madridExtendTop20.slice(
            10,
            madridExtendTop20.length
          );
        }
        if (res.data.madridTop10.length == 0) {
          this.havedata11 = false;
        } else {
          this.havedata11 = true;
          this.madridTop10 = res.data.madridTop10;
          this.madridTop50 = res.data.madridTop50;
        }

        Trademarke.mdl1sb();
        Trademarke.mdl2sb();
        Trademarke.mdl3sb();
      });
    },
    //  获取商标状态分析和区域商标比较
    getStatusAndRegion() {
      this.$GET("/trademark/tmLawAndAreaAly", {
        cnty: this.region,
        time: this.timevalueS,
        // time: "2019",
      }).then((res) => {
        this.$store.commit("getsbTwo", res.data);
        if (res.data.lawMap.length == 0) {
          this.havedata12 = false;
        } else {
          this.havedata12 = true;
          this.lawMap = res.data.lawMap;
        }
        if (res.data.areaTmCompMap.length == 0) {
          this.havedata13 = false;
        } else {
          this.havedata13 = true;
          this.areaTmCompMap = res.data.areaTmCompMap;
        }
        if (res.data.areaRegTmCompMap.length == 0) {
          this.havedata14 = false;
        } else {
          this.havedata14 = true;
          this.areaRegTmCompMap = res.data.areaRegTmCompMap;
        }
        if (res.data.areaMadridTmCompMap.length == 0) {
          this.havedata15 = false;
        } else {
          this.havedata15 = true;
          this.areaMadridTmCompMap = res.data.areaMadridTmCompMap;
        }
        Trademarke.statusSB();
        Trademarke.regionsbDCompare1();
        Trademarke.regionsbDCompare2();
        Trademarke.regionsbDCompare3();
      });
    },
    // 获取商标运营分析
    getManiAnay() {
      this.$GET("/trademark/tmOprAly", {
        cnty: this.region,
        time: this.timevalueS,
        // time: "2019",
      }).then((res) => {
        this.$store.commit("getsbyunying", res.data);
        if (res.data.tmTransferMap.length == 0) {
          this.havedata16 = false;
        } else {
          this.havedata16 = true;
          this.tmTransferMap = res.data.tmTransferMap;
          this.tmTransferMap.forEach((ele) => {
            ele.name = this.switchTime(ele.name);
          });
        }
        if (res.data.tmIcTrfTop.length == 0) {
          this.havedata17 = false;
        } else {
          this.havedata17 = true;
          this.tmIcTrfTop = res.data.tmIcTrfTop;
        }
        if (res.data.tmLicenseMap.length == 0) {
          this.havedata18 = false;
        } else {
          this.havedata18 = true;
          this.tmLicenseMap = res.data.tmLicenseMap;
          this.tmLicenseMap.forEach((ele) => {
            ele.name = this.switchTime(ele.name);
          });
        }
        if (res.data.tmIcLicTop.length == 0) {
          this.havedata19 = false;
        } else {
          this.havedata19 = true;
          this.tmIcLicTop = res.data.tmIcLicTop;
        }
        if (res.data.tmPledgeMap.length == 0) {
          this.havedata20 = false;
        } else {
          this.havedata20 = true;
          this.tmPledgeMap = res.data.tmPledgeMap;
          this.tmPledgeMap.forEach((ele) => {
            ele.name = this.switchTime(ele.name);
          });
        }
        if (res.data.tmIcPldTop.length == 0) {
          this.havedata21 = false;
        } else {
          this.havedata21 = true;
          this.tmIcPldTop = res.data.tmIcPldTop;
        }
        Trademarke.sbmani1SB();
        Trademarke.sbmani2SB();
        Trademarke.sbmani3SB();
        Trademarke.sbmani4SB();
        Trademarke.sbmani5SB();
        Trademarke.sbmani6SB();
      });
    },
    // 获取商标运营分析榜单
    getyunytop() {
      this.$GET("/trademark/tmOprAlyTop", {
        cnty: this.region,
        time: this.timevalueS,
        // time: "2019",
      }).then((res) => {
        this.$store.commit("sbyunytop", res.data);
        if (res.data.tmTrfTop10.length == 0) {
          this.havedata22 = false;
        } else {
          this.havedata22 = true;
          this.tmTrfTop10 = res.data.tmTrfTop10;
          this.tmTrfTop50 = res.data.tmTrfTop50;
        }
        if (res.data.tmLicTop10.length == 0) {
          this.havedata23 = false;
        } else {
          this.havedata23 = true;
          this.tmLicTop10 = res.data.tmLicTop10;
          this.tmLicTop50 = res.data.tmLicTop50;
        }
        if (res.data.tmPldTop10.length == 0) {
          this.havedata24 = false;
        } else {
          this.havedata24 = true;
          this.tmPldTop10 = res.data.tmPldTop10;
          this.tmPldTop50 = res.data.tmPldTop50;
        }

        Trademarke.sbmani7SB();
        Trademarke.sbmani7xkSB();
        Trademarke.sbmani7zySB();
      });
    },
    // 获取 区域服务机构分析
    getRegionService() {
      this.$GET("/trademark/areaAgentAly", {
        cnty: this.region,
        time: this.timevalueS,
        // time: "2019",
      }).then((res) => {
        this.$store.commit("regionService", res.data);
        if (res.data.agentDist.length == 0) {
          this.havedata25 = false;
        } else {
          this.havedata25 = true;
          this.agentDist = res.data.agentDist;
        }
        if (res.data.agentTmTop10.length == 0) {
          this.havedata26 = false;
        } else {
          this.havedata26 = true;
          this.agentTmTop10 = res.data.agentTmTop10;
          this.agentTmTop50 = res.data.agentTmTop50;
          this.agentTmTop50.forEach((item, index) => {
            this.agentTmTop50[index]["name"] = item.AG;
          });
        }
        if (res.data.malice.length == 0) {
          this.havedata27 = false;
        } else {
          this.havedata27 = true;
          this.malice = res.data.malice;
        }
        if (res.data.maliceAppTmTop10.length == 0) {
          this.havedata28 = false;
        } else {
          this.havedata28 = true;
          this.malice = res.data.malice;
          this.maliceAppTmTop10 = res.data.maliceAppTmTop10;
          this.maliceAppTmTop50 = res.data.maliceAppTmTop50;
          this.maliceAppTmTop50.forEach((item, index) => {
            this.maliceAppTmTop50[index]["name"] = item.ap;
          });
        }
        Trademarke.sbdlnum();
        Trademarke.sbslnumtop();
        Trademarke.noNormalsb();
        Trademarke.malicetop();
      });
    },
    // 查看更多top50
    seeMore50(value) {
      // console.log(value);
      this.seeMore = true;
      switch (value) {
        case 101:
          this.tableData50 = this.topApp50Map;
          this.label50 = "申请量";
          break;
        case 102:
          this.tableData50 = this.topReg50Map;
          this.label50 = "注册量";
          break;
        case 103:
          this.tableData50 = this.topValid50Map;
          this.label50 = "有效注册量";
          break;
        case 112:
          this.tableData50 = this.madridTop50;
          this.label50 = "马德里注册量";
          break;
        // case 105:
        //   this.tableData50 = this.pctTop50Count;
        //   this.label50 = "PCT公开量";
        //   break;
        case 106:
          this.tableData50 = this.tmTrfTop50;
          this.label50 = "商标转让量";
          break;
        case 107:
          this.tableData50 = this.tmLicTop50;
          this.label50 = "商标许可量";
          break;
        case 108:
          this.tableData50 = this.tmPldTop50;
          this.label50 = "商标质押量";
          break;
        case 109:
          this.tableData50 = this.agentTmTop50;
          this.label50 = "商标代理量";
          break;
        case 110:
          this.tableData50 = this.maliceAppTmTop50;
          this.label50 = "商标申请量";
          break;
      }
    },
    // 导出更多
    daochu(value) {
      // console.log(value)
      let aLink = document.createElement("a");
      aLink.href =
        this.$url +
        "/applicant/alyTopExport?token=" +
        localStorage.getItem("token") +
        "&uid=" +
        localStorage.getItem("uid") +
        "&cnty=" +
        this.region +
        "&time=" +
        this.timevalueS +
        // "2019" +
        "&key=" +
        value;
      aLink.click();
    },
    // 滚动条监听事件
    scrollHandle() {
      let scrollObj = document.querySelector(".contentBack5"); // 获取滚动区域
      let clientHeight = scrollObj.clientHeight; // 容器的高度
      let scrollTop = scrollObj.scrollTop; // 已滚动的距离

      let echartsObj1 = document.querySelector("#gntmtrend");
      let echartsHeight1 = echartsObj1.offsetTop; //当前表格离顶部的高度
      let echartsObj2 = document.querySelector("#applyertrend");
      let echartsHeight2 = echartsObj2.offsetTop;
      let echartsObj3 = document.querySelector("#mdltmtrend");
      let echartsHeight3 = echartsObj3.offsetTop;
      let echartsObj4 = document.querySelector("#sbstatusfx");
      let echartsHeight4 = echartsObj4.offsetTop;
      let echartsObj5 = document.querySelector("#sbturn1");
      let echartsHeight5 = echartsObj5.offsetTop;
      let echartsObj6 = document.querySelector("#sbagree1");
      let echartsHeight6 = echartsObj6.offsetTop;
      if (
        clientHeight + scrollTop > echartsHeight1 - 100 &&
        this.firstscroll1
      ) {
        this.firstscroll1 = false;
        this.gettopsb();
      }
      if (
        clientHeight + scrollTop > echartsHeight2 - 100 &&
        this.firstscroll2
      ) {
        this.firstscroll2 = false;
        this.getmdlsb();
      }
      if (
        clientHeight + scrollTop > echartsHeight3 - 100 &&
        this.firstscroll3
      ) {
        this.firstscroll3 = false;
        this.getStatusAndRegion();
      }
      if (
        clientHeight + scrollTop > echartsHeight4 - 100 &&
        this.firstscroll4
      ) {
        this.firstscroll4 = false;
        this.getManiAnay();
      }
      if (
        clientHeight + scrollTop > echartsHeight5 - 100 &&
        this.firstscroll5
      ) {
        this.firstscroll5 = false;
        this.getyunytop();
      }
      if (
        clientHeight + scrollTop > echartsHeight6 - 100 &&
        this.firstscroll6
      ) {
        this.firstscroll6 = false;
        this.getRegionService();
      }
    },
  },
  mounted() {
    let dom = document.getElementsByClassName("contentBack5")[0];
    if (dom) {
      dom.addEventListener("scroll", this.scrollHandle, true);
    }
    //   获取当前年
    let year = new Date().getFullYear();
    this.optionsTime[0].value = year;
    this.optionsTime[0].label = year + "年";
    this.optionsTime[1].value = year - 1;
    this.optionsTime[1].label = year - 1 + "年";
    let arr = [];
    this.$set(arr, 0, year);
    this.$set(arr, 1, "");
    this.timevalue = arr;
    // console.log("this.timevalue ", this.timevalue);
    this.timevalueS = this.timevalue.join("");
    // console.log("this.timevalueS ", this.timevalueS);

    // 获取当前季度
    // let season = Math.floor((new Date().getMonth() + 3) / 3);
    // var arr = [];
    // this.$set(arr, 0, year);
    // this.$set(arr, 1, season.toString());
    // this.timevalue = arr;
    // this.timevalueS = this.timevalue.join("");
    // 获取地区权限
    let DataPermission = JSON.parse(localStorage.getItem("DataPermission"));
    DataPermission.forEach((element, index) => {
      DataPermission[index]["value"] = element.name;
      DataPermission[index]["label"] = element.name;
    });
    // console.log(DataPermission)
    this.optionsRegion = DataPermission;
    // 统计
    this.sbAnalyCount();
    // 国内专利
    this.region = "全部区域";
    this.domasticsbDatas();
  },
  watch: {},
  destroyed() {
    window.removeEventListener("scroll", this.scrollHandle);
  },
};
</script>
<style>

.stats {
  width: 97%;
  /* height: 84px; */
  background-color: #fff;
  margin: 20px;
  display: flex;
  

}
.contentBack {
  width: 97.5%;
  height: 96%;
  background: #fff;
  position: absolute;
  bottom: 0;
  left: 20px;
}
  .trademark-one {
    width:17% ;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f8fbff;
    border: 0.5px solid #dddddd;

  }
   .trademark-img {
    margin-right: 10px;
    
  }
    .trademark-one i {
    color: #0064d0;
    font-size: 36px;
  }

  .trandemark-tit {
    margin-bottom: 5px;
    font-size: 16px;
  }
  .trandemark-num > span {
    color:  #2470f2;
    font-size: 16px;
  }
  .trandemark-num .trandemark-num1 {
    font-size: 14px;
    color: #414141;
  }
  .other-tips {
    float: right;
    font-size: 14px;
  }

</style>